
import RightSidebar from "../../MainContent/RightSidebar/RightSidebar";
import HeroesoFTajikistan from "./HeroesoFTajikistan";
import '../Tajikistan/Heroeso.css';
const Heroeso = () => {
    return (
        <div class="container">
            <div class="row g-5">


                {/* --------------------------------------------- PAGINATION------------------------------------- */}
                <HeroesoFTajikistan />
            </div>

            {/* -----------------------------------------------   RIGHT SIDEBAR------------------------------------- */}
            {/* <div class="col-md-3 col-lg-4 col-xl-4 pt-5">
                    <div class="position-sticky" >
                        <RightSidebar />
                    </div>
                </div> */}
        </div>
    )
}

export default Heroeso;